import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Generate or get session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('analytics_session');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substring(2, 15);
    sessionStorage.setItem('analytics_session', sessionId);
  }
  return sessionId;
};

// Track page view
const trackPageView = async (page) => {
  try {
    await fetch(`${API_URL}/api/analytics/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page,
        referrer: document.referrer,
        userAgent: navigator.userAgent,
        sessionId: getSessionId()
      })
    });
  } catch (error) {
    console.error('Analytics error:', error);
  }
};

// Track click event
export const trackClick = async (element) => {
  try {
    await fetch(`${API_URL}/api/analytics/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: window.location.pathname,
        element,
        sessionId: getSessionId()
      })
    });
  } catch (error) {
    console.error('Analytics click error:', error);
  }
};

// Analytics Provider Component
const Analytics = () => {
  const location = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    // Only track if path changed
    if (location.pathname !== lastPath.current) {
      lastPath.current = location.pathname;
      trackPageView(location.pathname);
    }
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default Analytics;
